import * as React from "react";

const InstagramIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 50 50"
    >
        <rect width="50" height="50" fill="#36387D" rx="8"></rect>
        <g clipPath="url(#clip0_2947_4128)">
            <path
                fill="#fff"
                d="M25 12c-3.53 0-3.973.015-5.36.079-1.383.063-2.328.282-3.155.603a6.4 6.4 0 0 0-2.302 1.5 6.4 6.4 0 0 0-1.5 2.302c-.323.827-.542 1.772-.605 3.156C12.016 21.026 12 21.47 12 25s.016 3.973.079 5.36c.063 1.383.282 2.328.603 3.154a6.4 6.4 0 0 0 1.5 2.303 6.4 6.4 0 0 0 2.302 1.5c.827.322 1.772.541 3.156.605 1.386.063 1.829.078 5.36.078 3.53 0 3.972-.015 5.358-.078 1.384-.064 2.33-.283 3.157-.604a6.4 6.4 0 0 0 2.301-1.5 6.4 6.4 0 0 0 1.5-2.303c.32-.827.54-1.772.605-3.156.062-1.386.078-1.828.078-5.359s-.016-3.974-.078-5.36c-.065-1.384-.285-2.329-.604-3.155a6.4 6.4 0 0 0-1.5-2.303 6.35 6.35 0 0 0-2.303-1.5c-.828-.321-1.774-.54-3.158-.604-1.386-.063-1.828-.078-5.36-.078zm-1.165 2.343H25c3.47 0 3.882.012 5.253.075 1.267.057 1.955.27 2.413.447a4 4 0 0 1 1.494.973c.455.455.737.888.973 1.495.178.457.39 1.145.448 2.413.062 1.37.076 1.782.076 5.251s-.014 3.881-.076 5.252c-.058 1.267-.27 1.955-.448 2.413a4 4 0 0 1-.973 1.493 4 4 0 0 1-1.494.972c-.457.18-1.146.39-2.413.448-1.37.063-1.782.076-5.253.076s-3.883-.013-5.253-.076c-1.268-.058-1.956-.27-2.414-.448a4 4 0 0 1-1.495-.972 4 4 0 0 1-.973-1.494c-.178-.458-.39-1.146-.447-2.413-.063-1.37-.075-1.783-.075-5.254 0-3.472.012-3.881.075-5.252.057-1.267.27-1.955.447-2.413.236-.607.518-1.04.973-1.495a4 4 0 0 1 1.495-.973c.458-.179 1.146-.39 2.414-.448 1.2-.055 1.664-.07 4.087-.074zM31.94 16.5a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12M25 18.324a6.676 6.676 0 1 0 .002 13.353A6.676 6.676 0 0 0 25 18.324m0 2.343a4.333 4.333 0 1 1 0 8.666 4.333 4.333 0 0 1 0-8.666"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2947_4128">
                <path fill="#fff" d="M12 12h26v26H12z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default InstagramIcon;
